import { onEmulator } from "./constants";
var isPreviewing = document.location.href.match(/(preview)|(wif)/g);
export function reportDebug(mssg) {
    if (onEmulator) {
        console.debug(mssg instanceof Function ? mssg() : mssg);
    }
}
export function reportInfo(mssg) {
    if (onEmulator || isPreviewing)
        console.info(mssg);
}
export function reportWarning(mssg) {
    console.warn(mssg);
}
export function reportError(mssg, err) {
    console.error(mssg + " [cause: " + (err ? err : "unknown") + "]");
}
//# sourceMappingURL=reporter.js.map